import { render, staticRenderFns } from "./transaction.vue?vue&type=template&id=f46615c8&scoped=true&"
import script from "./transaction.js?vue&type=script&lang=js&"
export * from "./transaction.js?vue&type=script&lang=js&"
import style0 from "./transaction.vue?vue&type=style&index=0&id=f46615c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46615c8",
  null
  
)

export default component.exports